export default {aggregate:"com.armus.product:hybrid-accsts-jsclient:2026.03.26:20260327-0234",
    client: "com.armus:hybrid-jsclient:2026.03.23:20260323-1655",
    requiredApiVersion: "1.86.0",
};



// WEBPACK FOOTER //
// ./app/version.js